import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import Containers from "../../Containers";
import Component from "../index";

const Main = ( props ) => {
	
	useEffect( () => {
		
		const fetchData = async () => {
			await props.Auth.try();
		}
		
		fetchData();
		
		}, [props] );
	
	return (
		<Router>
			{!props.Auth.token &&
			<>
				<Route path="/login">
					<Containers.Auth/>
				</Route>
			</>
			}
			{props.Auth.token &&
			<>
				<Component.Layout.Nav/>
				<Component.Layout.Aside/>
			</>
			}
		</Router>)
}

export default inject( 'Auth' )( (observer( Main )) )
